// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
   background-color: #fff;
   border-radius: 10px;
   color: #333;
   display: flex;
   flex-direction: column;
   padding: 20px;
   width: 500px;
   max-width: 100%;
}

form > h4 {
   font-size: 30px;
   margin: 0;
}

form > p {
   font-size: 18px;
   margin: 10px 0 20px 0;
}

form input {
   border: 1px solid #767676;
   border-radius: 5px;
   box-shadow: inset 0 0 0 1000px #fff;
   font-size: 14px;
   line-height: 37px;
   margin: 5px 0;
   outline: none;
   padding: 0 10px;
   transition: border-color .2s ease-in-out;
}

form input::-webkit-outer-spin-button,
form input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
form input[type=number] {
  -moz-appearance: textfield;
}

form input:focus {
   border-color: #3456FF;
}

form button {
   background-color: darkblue;
   border: 1px solid darkblue;
   border-radius: 25px;
   color: #fff;
   cursor: pointer;
   font-size: 24px;
   height: 40px;
   margin-top: 5px;
   outline: none;
   transition: .2s background-color ease-in-out;
   width: 100%;
}

form button:hover {
   background-color: #2440ca;
}

form button:disabled {
   background-color: lightgray;
   border-color: lightgray;
   cursor: default;
}

form span {
   color: gray;
   cursor: pointer;
   font-size: 15px;
   padding: 15px 0;
}

form span:hover {
   text-decoration: underline;
}

form .result {
   font-size: 16px;
}

/* Slider Track */
form input[type="range"] {
  width: 100%;
  height: 18px;
  background-color: #282c34;
  border-radius: 90px;
  appearance: none;
  outline: crimson;
  margin-bottom: 20px;
}

/* Slider Thumb */
form input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  background: darkblue;
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/Form.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,mBAAmB;GACnB,WAAW;GACX,aAAa;GACb,sBAAsB;GACtB,aAAa;GACb,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,SAAS;AACZ;;AAEA;GACG,eAAe;GACf,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,mCAAmC;GACnC,eAAe;GACf,iBAAiB;GACjB,aAAa;GACb,aAAa;GACb,eAAe;GACf,wCAAwC;AAC3C;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,0BAA0B;GAC1B,0BAA0B;GAC1B,mBAAmB;GACnB,WAAW;GACX,eAAe;GACf,eAAe;GACf,YAAY;GACZ,eAAe;GACf,aAAa;GACb,4CAA4C;GAC5C,WAAW;AACd;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,2BAA2B;GAC3B,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,eAAe;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["form {\n   background-color: #fff;\n   border-radius: 10px;\n   color: #333;\n   display: flex;\n   flex-direction: column;\n   padding: 20px;\n   width: 500px;\n   max-width: 100%;\n}\n\nform > h4 {\n   font-size: 30px;\n   margin: 0;\n}\n\nform > p {\n   font-size: 18px;\n   margin: 10px 0 20px 0;\n}\n\nform input {\n   border: 1px solid #767676;\n   border-radius: 5px;\n   box-shadow: inset 0 0 0 1000px #fff;\n   font-size: 14px;\n   line-height: 37px;\n   margin: 5px 0;\n   outline: none;\n   padding: 0 10px;\n   transition: border-color .2s ease-in-out;\n}\n\nform input::-webkit-outer-spin-button,\nform input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\nform input[type=number] {\n  -moz-appearance: textfield;\n}\n\nform input:focus {\n   border-color: #3456FF;\n}\n\nform button {\n   background-color: darkblue;\n   border: 1px solid darkblue;\n   border-radius: 25px;\n   color: #fff;\n   cursor: pointer;\n   font-size: 24px;\n   height: 40px;\n   margin-top: 5px;\n   outline: none;\n   transition: .2s background-color ease-in-out;\n   width: 100%;\n}\n\nform button:hover {\n   background-color: #2440ca;\n}\n\nform button:disabled {\n   background-color: lightgray;\n   border-color: lightgray;\n   cursor: default;\n}\n\nform span {\n   color: gray;\n   cursor: pointer;\n   font-size: 15px;\n   padding: 15px 0;\n}\n\nform span:hover {\n   text-decoration: underline;\n}\n\nform .result {\n   font-size: 16px;\n}\n\n/* Slider Track */\nform input[type=\"range\"] {\n  width: 100%;\n  height: 18px;\n  background-color: #282c34;\n  border-radius: 90px;\n  appearance: none;\n  outline: crimson;\n  margin-bottom: 20px;\n}\n\n/* Slider Thumb */\nform input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 25px;\n  height: 25px;\n  border-radius: 100%;\n  background: darkblue;\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
